import { createUseStyles } from 'react-jss';

export const createSelectStyles = (touched, error, grayBackground) => {
  const backgroundColor = grayBackground ? '#f3f6f9' : 'white';
  return {
    menu: () => ({
      bottom: '4px',
      position: 'relative',
      right: '10px',
      marginLeft: 10,
      marginRight: 10,
      width: '100%',
      boxShadow: 'none',
      zIndex: '20',
    }),

    menuList: base => ({
      ...base,
      borderBottomLeftRadius: '18px',
      borderBottomRightRadius: '18px',
    }),

    control: (base, state) => {
      let borderStyle;

      if (state.isFocused) {
        borderStyle = 'none';
      } else if (touched && state.selectProps.value) {
        borderStyle = '1px solid #4CD137';
      } else if (error) {
        borderStyle = '1px solid #E84118';
      } else {
        borderStyle = 'none';
      }

      const showBorderBottom = state.selectProps.value ||
        (state.isFocused ? !state.menuIsOpen : error);

      return {
        ...base,
        backgroundColor,
        borderRadius: '12px',
        borderBottomLeftRadius: state.menuIsOpen ? 0 : '12px',
        borderBottomRightRadius: state.menuIsOpen ? 0 : '12px',
        border: borderStyle,
        borderBottom: showBorderBottom ? borderStyle : 'none',
        '&:hover': {
          boxShadow: '0px 16px 32px rgba(16, 33, 49, 0.08)',
        },
        boxShadow: 0,
        height: '50px',
        cursor: 'pointer',
        transition: 'all 0.15s ease-in-out',
      };
    },

    indicatorSeparator: () => ({
      display: 'none',
    }),

    indicatorsContainer: base => ({
      ...base,
      position: 'relative',
      right: '12px',
    }),

    placeholder: base => ({
      ...base,
      color: '#B2B9C0',
      fontSize: '14px',
      // marginLeft: ''
    }),

    dropdownIndicator: (base, state) => ({
      ...base,
      '& svg': { display: 'none' },
      '&::before': {
        content: '""',
        width: 0,
        height: 0,
        border: '5px solid #8986a1',
        borderBottomWidth: '0',
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
      },
    }),

    valueContainer: base => ({
      ...base,
      padding: '22px 16px 22px 57px',
      height: '50px',
      color: '#B2B9C0',
      fontSize: '16px',
      alignItems: 'center',
      flexWrap: 'nowrap',
    }),

    singleValue: base => ({
      ...base,
      color: '#102131',
      fontSize: '16px',
    }),
    option: (base, state) => {
      const color = state.isSelected ? '#102131' : '#B2B9C0';
      const bgColor = state.isFocused ? '#FAFCFF' : '#FFFFFF';
      const borderLeft = state.isSelected ? '1px solid #102131' : 'none';
      return {
        ...base,
        backgroundColor: bgColor,
        color,
        fontWeight: 400,
        cursor: 'pointer',
        border: 'none',
        borderLeft,
      };
    },
  };
};

export const useStyles = createUseStyles({
  selectContainer: {
    position: 'relative',
  },
  title: {
    color: '#AABAA5',
    position: 'absolute',
    top: '-24px',
    left: '12px',
    fontSize: '12px',
  },
  image: {
    position: 'absolute',
    top: '14px',
    left: '19px',
    cursor: 'pointer',
    pointerEvents: 'none',
  },
  statusIcon: {
    position: 'absolute',
    top: '15px',
    right: '40px',
    cursor: 'pointer',
    pointerEvents: 'none',
  },
  optionIcon: {
    float: 'right',
    marginRight: '6px',
    width: '18px',
    height: '18px',
    currsor: 'pointer',
  },
});
